/* @flow */

import Immutable from 'immutable';
import { NotificationConstants } from '../constants/notification_constants';
import { SharedConstants } from '../constants/shared_constants';

const notificationInitialState = Immutable.fromJS({
  errors: [],
  successes: [],
  notFound: false
});

function notificationReducer(state: Immutable.Map = notificationInitialState, action: Object): Immutable.Map {
  switch (action.type) {
    case SharedConstants.SHARED_PURGE:
      return notificationInitialState;
    case NotificationConstants.NOTIFICATION_ERROR_DISMISS:
      return state.update('errors', errors => errors.shift());
    case NotificationConstants.NOTIFICATION_NOT_FOUND:
      return state.set('notFound', action.value);
    case NotificationConstants.NOTIFICATION_ERROR:
      // Ignore duplicate errors
      var match = state.get('errors').some((error) => error.message === action.error.message);
      if (!match) {
        var err = action.error;
        state = state.update('errors', errors => errors.push(err));
      }
      break;
    case NotificationConstants.NOTIFICATION_DISABLED_ERROR:
      action.error.disabledError = true;
      return state.update('errors', errors => errors.push(action.error));
    case NotificationConstants.NOTIFICATION_RESET_ERROR:
      return state.update('errors', errors => errors.push(action.error));
    case NotificationConstants.NOTIFICATION_SUCCESS:
      return state.update('successes', successes => successes.push(action.message));
    case NotificationConstants.NOTIFICATION_SUCCESS_DISMISS:
      return state
        .update('successes', successes => successes.shift());
  }
  return state;
}

export {
  notificationInitialState,
  notificationReducer
};
